import React, { useState, useEffect } from 'react';
import './DropDown.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function DropDown({ onSelect, items, className, selectedItem }) {
  const [open, setOpen] = useState(false);
  if (logComponent('DropDown')) { console.debug('DropDown rendered'); }

  useEffect(() => {
    if (logComponent('DropDown')) { console.debug('DropDown onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    window.addEventListener('click', close);
    return function cleanup() {
      window.removeEventListener('click', close);
    };
  }, []);

  const close = () => {
    if (logComponent('DropDown')) { console.debug('DropDown close'); }
    if (open) {
      setOpen(false);
    }
  }

  const select = (e) => {
    if (logComponent('DropDown')) { console.debug('DropDown select'); }
    e.stopPropagation();
    const { item } = e.target.dataset;

    close();
    onSelect(item);
  }

  const toggle = (e) => {
    if (logComponent('DropDown')) { console.debug('DropDown toggle'); }
    e.stopPropagation();
    setOpen(!open);
  }

  return (
    <div className={'Drop-Down' + (className ? ' ' + className : '')}>
      <button 
        onClick={ toggle }
        className="Drop-Down__selection-box">
        <span className="Drop-Down__selection">
          { selectedItem }
        </span>
        <div className={'Drop-Down__toggle-icon' + (open ? ' Drop-Down__toggle-icon--open' : '')}>
          <FontAwesomeIcon icon="chevron-down"></FontAwesomeIcon>
        </div>

      </button>

      <ul className={'Drop-Down__item-list' + (!open ? ' hidden' : '')}>
        { items.map(item => 
          <li 
            key={ item }
            className={'Drop-Down__item' + (item === selectedItem ? ' Drop-Down__item--selected' : '')}>
            <button 
              data-item={ item }
              onClick={ select }>
              { item }
            </button>
          </li>) }
      </ul>
    </div>
  );
}